import { render, staticRenderFns } from "./StudentPerformance.vue?vue&type=template&id=59bbb1d3&scoped=true&"
import script from "./StudentPerformance.vue?vue&type=script&lang=js&"
export * from "./StudentPerformance.vue?vue&type=script&lang=js&"
import style0 from "./StudentPerformance.vue?vue&type=style&index=0&id=59bbb1d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bbb1d3",
  null
  
)

component.options.__file = "StudentPerformance.vue"
export default component.exports